﻿import { extend, formattedNumber } from 'Furillo/modules/helpers.js';
import Carousel from 'Vendor/bootstrap/js/dist/carousel.js';
// Full https://www.chartjs.org/ library
//import Chart from 'Vendor/chart.js/auto/auto.js';
import { Chart, Decimation, Filler, Tooltip, DoughnutController, ArcElement } from 'Vendor/chart.js/dist/chart.js';
import ChartDataLabels from 'Vendor/chartjs-plugin-datalabels';

export default class EsemBlockInteractiveDiagram {

    constructor(element, options) {

        const defaults = {};

        this.element = element;
        this.options = extend(defaults, options);
        this.chart = null;
        this.chartData = [];

        this.init();
    }

    getContrast(hexcolor) {

        // If a leading # is provided, remove it
        if (hexcolor.slice(0, 1) === '#') {
            hexcolor = hexcolor.slice(1);
        }

        // If a three-character hexcode, make six-character
        if (hexcolor.length === 3) {
            hexcolor = hexcolor.split('').map(function (hex) {
                return hex + hex;
            }).join('');
        }

        // Convert to RGB value
        var r = parseInt(hexcolor.substr(0, 2), 16);
        var g = parseInt(hexcolor.substr(2, 2), 16);
        var b = parseInt(hexcolor.substr(4, 2), 16);

        // Get YIQ ratio
        var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

        // Check contrast
        return (yiq >= 128) ? 'black' : 'white';

    };

    initDoughnutChart() {
        const self = this;

        if (!self.chartData || self.chartData.length === 0)
            return;


        const canvas = self.element.querySelector('canvas[id^="chart-"]');
        const data = {
            labels: self.chartData.map(v => v.percent + '%'),
            datasets: [{
                data: self.chartData.map(v => v.percent),
                backgroundColor: (context) => {
                    const chart = context.chart;
                    const { ctx, chartArea } = chart;
                    if (!chartArea)
                        return null;

                    return self.chartData[context.dataIndex].color;
                }
            }]
        };

        const config = {
            type: 'doughnut',
            data: data,
            plugins: [ChartDataLabels],
            options: {
                cutout: '40%',                
                plugins: {
                    datalabels: {
                        formatter: function (value, context) {
                            return context.chart.data.labels[context.dataIndex];
                        },
                        color: function (context) {
                            const { ctx, chartArea } = context.chart;

                            if (!chartArea) {
                                // This case happens on initial chart load
                                return;
                            }

                            return self.getContrast(self.chartData[context.dataIndex].color);
                        },
                        font: {
                            family: '"Roboto", sans-serif, Arial',
                            size: 24
                        }
                    },
                    tooltip: {
                        enabled: false
                    }
                },
                onHover: (event) => {

                    //console.log(event);

                    //if (event.native.type === 'mouseout' || event.native.type === 'mouseleave') {
                                                
                    //    // Prevent the default behavior (hiding tooltip/active state)
                    //    event.native.preventDefault();
                    //    // Optionally, keep the current active elements
                    //    // chart.setActiveElements([{datasetIndex: 0, index: 1}]);
                    //    return;
                    //}

                    if (event.type !== 'mousemove')
                        return;

                    //event.native.preventDefault();

                    const points = event.chart.getElementsAtEventForMode(event, 'nearest', { intersect: false }, true);

                    if (points.length !== 1)
                        return;

                    const carousel = Carousel.getOrCreateInstance(self.element.querySelector('.carousel'));
                    carousel.to(points[0].index);

                    //self.chart.setActiveElements([{ datasetIndex: 0, index: points[0].index }]);
                }
            }
        };

        self.chart = new Chart(canvas, config);

        self.chart.setActiveElements([{ datasetIndex: 0, index: 0, }]);
    }


    init() {
        const self = this;

        self.element.querySelectorAll('div.data-point').forEach(element => {
            self.chartData.push({ percent: parseFloat(element.getAttribute('data-percent')), color: element.getAttribute('data-color'), id: element.id });
        });

        // Only needed when not using 'auto'
        Chart.register(Decimation, Filler, Tooltip, DoughnutController, ArcElement, ChartDataLabels);

        self.initDoughnutChart();
    }
}